import * as React from 'react';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import {
    Modal,
    Button,
    ButtonGroup,
    FormGroup,
    FormControl,
    ControlLabel,
    Row,
    Col
} from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import { assign } from '../../shared/Assign';
import * as actions from './InvoiceActions';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import SuccessSnackbar from '../../shared/feedback/SuccessSnackbar';
import moment from 'moment';

class CustomerInvoiceModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            invoiceToShowBrokerFirmId: props.invoiceToShowBrokerFirmId,
            invoiceToShowInvoiceChecksum: props.invoiceToShowInvoiceChecksum,
            invoiceDate: props.invoiceDate,
            message: null,
            otherFirmName: null,
            otherInvoiceAddress: null,
            creating: false,
            exchangeRate: null,
            created: false,
            hasError: false,
            loading: true,
            errors: {},
            showVoidConfirmation: false,
            showVoidSuccessSnackbar: false
        };

        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.onOtherFirmNameChange = this.onOtherFirmNameChange.bind(this);
        this.onOtherInvoiceAddressChange = this.onOtherInvoiceAddressChange.bind(this);
        this.update = this.update.bind(this);
        this.create = this.create.bind(this);
        this.print = this.print.bind(this);
        this.onExchangeRateChange = this.onExchangeRateChange.bind(this);
    }

    componentDidMount(): void {
        this.update();
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.invoiceCurrency && nextProps.legalEntityCurrency) {
            let exchangeRate = this.getExchangeRateInSessionStorage(
                nextProps.invoiceCurrency.displayName,
                nextProps.legalEntityCurrency.displayName
            );
            this.setState({ exchangeRate: exchangeRate });
        }
    }

    update(): void {
        this.props.actions
            .new(
                this.state.invoiceDate,
                this.state.message,
                this.state.otherFirmName,
                this.state.otherInvoiceAddress,
                this.state.invoiceToShowBrokerFirmId,
                this.state.invoiceToShowInvoiceChecksum
            )
            .then(() => {
                this.setState({ hasError: false, loading: false });
            })
            .catch((error: any) => {
                handleError(error);
                this.setState({ hasError: true });
            });
    }

    create(): void {
        this.setState({ creating: true });
        this.getExchangeRateInSessionStorage(
            this.props.invoiceCurrency.displayName,
            this.props.legalEntityCurrency.displayName,
            this.state.exchangeRate
        );

        this.props.actions
            .create(
                this.state.invoiceDate,
                this.props.language,
                this.state.message,
                this.state.otherFirmName,
                this.state.otherInvoiceAddress,
                this.state.invoiceToShowBrokerFirmId,
                this.state.invoiceToShowInvoiceChecksum,
                this.state.exchangeRate
            )
            .then(() => {
                this.setState({ creating: false, created: true });
            })
            .catch((error: any) => {
                this.setState({ creating: false });
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors });
                });
            });
    }

    print(): void {
        window.print();
    }

    onDateTimeChange(moment: any): void {
        let newState = assign({}, this.state);
        newState.invoiceDate = moment ? moment.toDate() : null;
        this.setState(newState);
    }

    onMessageChange(e: any): void {
        let newState = assign({}, this.state);
        newState.message = e.target.value;
        this.setState(newState);
    }

    onOtherFirmNameChange(e: any): void {
        let newState = assign({}, this.state);
        newState.otherFirmName = e.target.value;
        this.setState(newState);
    }

    onOtherInvoiceAddressChange(e: any): void {
        let newState = assign({}, this.state);
        newState.otherInvoiceAddress = e.target.value;
        this.setState(newState);
    }

    onExchangeRateChange(e: any): void {
        let newState = assign({}, this.state);
        newState.exchangeRate = e.target.value;
        this.setState(newState);
    }

    setExchangeRateInSessionStorage(
        fromCurrency: string,
        toCurrency: string,
        exchangeRate: number
    ) {
        if (fromCurrency === toCurrency) {
            return;
        }

        sessionStorage.setItem(`${fromCurrency} - ${toCurrency}`, JSON.stringify(exchangeRate));
    }

    getExchangeRateInSessionStorage(fromCurrency: string, toCurrency: string): string {
        let exchangeRate = sessionStorage.getItem(`${fromCurrency} - ${toCurrency}`);

        if (exchangeRate === null) {
            sessionStorage.removeItem(`${fromCurrency} - ${toCurrency}`);
            return null;
        }

        return JSON.parse(exchangeRate);
    }

    handleVoidInvoice = () => {
        this.setState({ creating: true });

        this.props.actions
            .markAsVoid(
                this.state.invoiceDate,
                this.props.language,
                this.state.message,
                this.state.otherFirmName,
                this.state.otherInvoiceAddress,
                this.state.invoiceToShowBrokerFirmId,
                this.state.invoiceToShowInvoiceChecksum,
            )
            .then(() => {
                this.setState({ creating: false, created: true, showVoidSuccessSnackbar: true });
                if (this.props.onSearch) {
                    this.props.onSearch();
                }
            })
            .catch((error: any) => {
                this.setState({ creating: false });
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors });
                });
            });        
    };
    
    render() {
        return (
            <div>
                <Modal show={true} onHide={this.props.closeModal} dialogClassName="modal-size">
                    <Modal.Header closeButton>
                        {!this.state.loading && (
                            <Modal.Title>
                                {Translate('invoice/new/title')} {this.props.receiver}
                            </Modal.Title>
                        )}
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={9} className="invoice-preview-column">
                                {this.props.newInvoice && !this.state.loading && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.newInvoice
                                        }}
                                    />
                                )}
                                {this.state.loading && <i className="load-spin-dark" />}
                            </Col>
                            <Col xs={12} lg={3} className="hide-print invoice-modifier-column">
                                {!this.state.created && (
                                    <div className="sticky-invoice-form">
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'invoice/new/form/input-label/invoice-date'
                                                )}
                                            </ControlLabel>
                                            <DateTime
                                                locale={moment.locale()}
                                                value={this.state.invoiceDate}
                                                timeFormat={false}
                                                onChange={this.onDateTimeChange}
                                                closeOnSelect={true}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate('invoice/new/form/input-label/message')}
                                            </ControlLabel>
                                            <FormControl
                                                autoFocus
                                                componentClass="textarea"
                                                name="message"
                                                className="text-area-roomy"
                                                value={this.state.message ? this.state.message : ''}
                                                onChange={this.onMessageChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'invoice/new/form/input-label/other-firm-name'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                autoFocus
                                                type="text"
                                                name="otherFirmName"
                                                value={
                                                    this.state.otherFirmName
                                                        ? this.state.otherFirmName
                                                        : ''
                                                }
                                                onChange={this.onOtherFirmNameChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                {Translate(
                                                    'invoice/new/form/input-label/other-invoice-address'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                autoFocus
                                                componentClass="textarea"
                                                name="otherInvoiceAddress"
                                                className="text-area-roomy"
                                                value={
                                                    this.state.otherInvoiceAddress
                                                        ? this.state.otherInvoiceAddress
                                                        : ''
                                                }
                                                onChange={this.onOtherInvoiceAddressChange}
                                            />
                                        </FormGroup>
                                        {this.props.legalEntityCurrency &&
                                            this.props.invoiceCurrency &&
                                            this.props.legalEntityCurrency.value !==
                                                this.props.invoiceCurrency.value && (
                                                <FormGroup>
                                                    <ControlLabel>
                                                        {Translate(
                                                            'invoice/new/form/input-label/exchange-rate',
                                                            {
                                                                invoiceCurrency:
                                                                    this.props.invoiceCurrency
                                                                        .displayName,
                                                                legalEntityCurrency:
                                                                    this.props.legalEntityCurrency
                                                                        .displayName
                                                            }
                                                        )}
                                                    </ControlLabel>
                                                    <FormControl
                                                        autoFocus
                                                        type="number"
                                                        name="exchangeRate"
                                                        value={
                                                            this.state.exchangeRate
                                                                ? this.state.exchangeRate
                                                                : ''
                                                        }
                                                        onChange={this.onExchangeRateChange}
                                                    />
                                                </FormGroup>
                                            )}

                                        {!this.state.creating && !this.state.loading && (
                                            <ButtonGroup>
                                                <Button
                                                    onClick={this.props.closeModal}
                                                    bsStyle="default"
                                                >
                                                    {Translate('invoice/close')}
                                                </Button>
                                                {!this.state.created && (
                                                    <Button
                                                        onClick={() => this.update()}
                                                        bsStyle="default"
                                                    >
                                                        {Translate('invoice/update')}
                                                    </Button>
                                                )}
                                                {!this.state.hasError && (
                                                    <Button
                                                        onClick={() => this.print()}
                                                        bsStyle="primary"
                                                    >
                                                        {Translate('invoice/print')}
                                                    </Button>
                                                )}
                                                {!this.state.created && !this.state.hasError && (
                                                    <Button
                                                        style={{
                                                            marginLeft: '0'
                                                        }}
                                                        onClick={() => this.create()}
                                                        bsStyle="primary"
                                                    >
                                                        {this.props.invoiceOnEmail
                                                            ? Translate('invoice/save-and-send')
                                                            : Translate('invoice/save')}
                                                    </Button>
                                                )}
                                            </ButtonGroup>
                                        )}
                                        {this.props.invoiceTotalSum === 0 && (
                                            <div style={{ marginTop: '16px', textAlign: 'left' }}>
                                                <Button
                                                    onClick={() => this.setState({ showVoidConfirmation: true })}
                                                    bsStyle="danger"
                                                >
                                                    {Translate('invoice/button-label/mark-as-void')}
                                                </Button>
                                            </div>
                                        )}
                                        {this.state.creating && <i className="load-spin-dark" />}
                                    </div>
                                )}
                                <SuccessSnackbar
                                    open={this.state.showVoidSuccessSnackbar}
                                    onClose={() => this.setState({ showVoidSuccessSnackbar: false })}
                                    text={Translate('invoice/void/success')}
                                />
                                {this.state.showVoidConfirmation && (
                                    <ConfirmationModal
                                        title={Translate('invoice/void/confirmation/title')}
                                        text={Translate('invoice/void/confirmation/description')}
                                        doButtonLabel={Translate('invoice/button-label/mark-as-void')}
                                        cancelButtonLabel={Translate('delete/modal/footer/button-label/cancel')}
                                        doButtonStyle="danger"
                                        do={this.handleVoidInvoice}
                                        closeModal={() => this.setState({ showVoidConfirmation: false })}
                                        dialogClassName="void-confirmation-modal"
                                    />
                                )}
                                {this.state.created && !this.state.loading && (
                                    <div className="sticky-invoice-form">
                                        <Button
                                            onClick={() => this.print()}
                                            bsStyle="primary"
                                            className="pull-right"
                                        >
                                            {Translate('invoice/print')}
                                        </Button>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        newInvoice: state.invoices.newInvoice.renderedTemplate,
        receiver: state.invoices.newInvoice.receiver,
        invoiceOnEmail: state.invoices.newInvoice.invoiceOnEmail,
        language: state.invoices.newInvoice.language,
        invoiceCurrency: state.invoices.newInvoice.invoiceCurrency,
        legalEntityCurrency: state.invoices.newInvoice.legalEntityCurrency,
        invoiceTotalSum: state.invoices.newInvoice.invoiceTotalSum
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: (
                invoiceDate: any,
                message: string,
                otherFirmName: string,
                otherInvoiceAddress: string,
                invoiceToShowBrokerFirmId: number,
                invoiceToShowInvoiceChecksum: number
            ) =>
                dispatch(
                    actions.getNewInvoice(
                        invoiceDate,
                        message,
                        otherFirmName,
                        otherInvoiceAddress,
                        invoiceToShowBrokerFirmId,
                        invoiceToShowInvoiceChecksum
                    )
                ),
            create: (
                invoiceDate: any,
                language: string,
                message: string,
                otherFirmName: string,
                otherInvoiceAddress: string,
                invoiceToShowBrokerFirmId: number,
                invoiceToShowInvoiceChecksum: number,
                exchangeRate: number
            ) =>
                dispatch(
                    actions.createInvoice(
                        invoiceDate,
                        language,
                        message,
                        otherFirmName,
                        otherInvoiceAddress,
                        invoiceToShowBrokerFirmId,
                        invoiceToShowInvoiceChecksum,
                        exchangeRate
                    )
                ),
            markAsVoid: (
                invoiceDate: any,
                language: string,
                message: string,
                otherFirmName: string,
                otherInvoiceAddress: string,
                invoiceToShowBrokerFirmId: number,
                invoiceToShowInvoiceChecksum: number
            ) =>
                dispatch(
                    actions.markAsVoid(
                        invoiceDate,
                        language,
                        message,
                        otherFirmName,
                        otherInvoiceAddress,
                        invoiceToShowBrokerFirmId,
                        invoiceToShowInvoiceChecksum
                    )
                ),
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInvoiceModal);
